import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";

export default function ExcelViewerModal({ open, onClose, fileUrl, fileName }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (!fileUrl) return null;

  // Microsoft Office Online viewer URL
  const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;

  const handleDownload = () => {
    window.open(fileUrl, '_blank');
  };

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const handleIframeError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '85vh',
          maxHeight: '85vh',
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        borderBottom={1}
        borderColor="divider"
      >
        <IconButton onClick={onClose} size="small" sx={{ visibility: 'hidden' }}>
          <CloseIcon />
        </IconButton>
        <Box display="flex" alignItems="center" gap={1} flex={1} justifyContent="center">
          <Typography variant="h6" component="div" noWrap sx={{ maxWidth: '600px', color: 'black', fontWeight: 500 }}>
            {fileName || 'Excel Preview'}
          </Typography>
        </Box>
        <Box display="flex" gap={1}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
          >
            Download Excel File
          </Button>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      <DialogContent sx={{ p: 0, position: 'relative', display: 'flex', flexDirection: 'column' }}>
        {loading && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            minHeight="70vh"
          >
            <Box textAlign="center">
              <CircularProgress />
              <Typography mt={2} color="text.secondary">
                Loading Excel preview...
              </Typography>
            </Box>
          </Box>
        )}

        {error && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="70vh"
            gap={2}
          >
            <Typography variant="body1" color="text.secondary">
              Unable to preview this file
            </Typography>
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={handleDownload}
            >
              Download File
            </Button>
          </Box>
        )}

        {!error && (
          <iframe
            src={viewerUrl}
            title={fileName || 'Excel Preview'}
            style={{
              width: '100%',
              height: '75vh',
              border: 'none',
              display: loading ? 'none' : 'block',
            }}
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

